import React from 'react';
import { useNavigate } from 'react-router-dom';

const styles = {
  bg: {
    minHeight: '100vh',
    width: '100vw',
    background: 'linear-gradient(120deg, #fff 0%, #ffe5e5 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
  },
  glassCard: {
    background: 'rgba(255,255,255,0.85)',
    boxShadow: '0 8px 40px 0 rgba(255,0,0,0.10), 0 1.5px 6px rgba(0,0,0,0.04)',
    borderRadius: 36,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    padding: '48px 32px 40px 32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 420,
    width: '90vw',
    backdropFilter: 'blur(8px)',
    border: '1.5px solid #ffe5e5',
    margin: '32px 0',
  },
  logoCircle: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.7)',
    boxShadow: '0 4px 32px #ffb3b3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    marginTop: 0,
    border: '2.5px solid #fff',
    position: 'relative',
    zIndex: 2,
  },
  logo: {
    width: 90,
    height: 90,
    objectFit: 'contain',
    borderRadius: '50%',
    filter: 'drop-shadow(0 2px 12px #ffb3b3)',
    background: 'transparent',
  },
  welcomeText: {
    fontFamily: 'Montserrat Black, Poppins, Arial, sans-serif',
    fontSize: 44,
    fontWeight: 900,
    marginBottom: 10,
    color: '#b00',
    textAlign: 'center',
    letterSpacing: 1.5,
    textShadow: '0 2px 12px #ffe5e5',
    lineHeight: 1.1,
  },
  tagline: {
    fontFamily: 'Poppins, Arial, sans-serif',
    fontSize: 22,
    fontWeight: 600,
    color: '#333',
    marginBottom: 36,
    textAlign: 'center',
    letterSpacing: 0.5,
    opacity: 0.85,
  },
  divider: {
    width: '60%',
    height: 2,
    background: 'linear-gradient(90deg, #ffb3b3 0%, #fff 100%)',
    margin: '18px 0 32px 0',
    borderRadius: 2,
    boxShadow: '0 1px 8px #ffe5e5',
  },
  button: {
    fontFamily: 'Montserrat Black, Poppins, Arial, sans-serif',
    background: 'linear-gradient(90deg, #ff0000 60%, #ff4d4d 100%)',
    padding: '22px 0',
    borderRadius: 999,
    marginBottom: 22,
    border: 'none',
    color: '#fff',
    fontSize: 28,
    fontWeight: 900,
    cursor: 'pointer',
    width: 340,
    maxWidth: '90vw',
    boxShadow: '0 6px 32px #ffb3b3',
    letterSpacing: 1.5,
    transition: 'transform 0.14s, box-shadow 0.14s',
    outline: 'none',
    lineHeight: 1.1,
  },
  dashboardButton: {
    fontFamily: 'Montserrat Black, Poppins, Arial, sans-serif',
    background: 'linear-gradient(90deg, #007bff 60%, #0056b3 100%)',
    padding: '18px 0',
    borderRadius: 999,
    marginBottom: 22,
    border: 'none',
    color: '#fff',
    fontSize: 22,
    fontWeight: 700,
    cursor: 'pointer',
    width: 340,
    maxWidth: '90vw',
    boxShadow: '0 4px 20px rgba(0,123,255,0.3)',
    letterSpacing: 1,
    transition: 'transform 0.14s, box-shadow 0.14s',
    outline: 'none',
    lineHeight: 1.1,
  },
  buttonHover: {
    transform: 'scale(1.045)',
    boxShadow: '0 12px 40px #ffb3b3',
  },
};

export default function WelcomeScreen() {
  const navigate = useNavigate();
  const [hovered, setHovered] = React.useState(null);

  return (
    <div style={styles.bg}>
      {/* Google Fonts for Montserrat Black and Poppins */}
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@900&family=Poppins:wght@600&display=swap" rel="stylesheet" />
      <div style={styles.glassCard}>
        <div style={styles.logoCircle}>
          <img
            src="https://i.ibb.co/4WR9x4Z/logo-removebg-preview.png"
            alt="Logo"
            style={styles.logo}
          />
        </div>
        <div style={styles.welcomeText}>Welcome!</div>
        <div style={styles.tagline}>Cleanliness is <span style={{ color: '#b00', fontWeight: 900 }}></span>lifesytle<br />Enjoy a <span style={{ color: '#b00', fontWeight: 900 }}>spotless</span> life with <span style={{ color: '#b00', fontWeight: 900 }}>Married to the Mop</span>.</div>
        <div style={styles.divider} />
        <button
          style={hovered === 1 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(1)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/form1')}
        >
          Risk Assessment Form
        </button>
        <button
          style={hovered === 2 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(2)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/form2')}
        >
          Method Statement Form
        </button>
        <button
          style={hovered === 3 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(3)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/form3')}
        >
          Biohazard Report Form
        </button>
        <button
          style={hovered === 4 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(4)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/quality-review')}
        >
          Quality Review Form
        </button>
        <button
          style={hovered === 5 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(5)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/waste-transfer')}
        >
          Waste Transfer Form
        </button>
        <button
          style={hovered === 6 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(6)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/fettler')}
        >
          Fettlers Form
        </button>
        <button
          style={hovered === 7 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(7)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/eec')}
        >
          EEC Observation Report
        </button>
        <button
          style={hovered === 8 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(8)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/hwmoon')}
        >
          HW Moon Toyota Cleaning Checklist
        </button>
        <button
          style={hovered === 9 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(9)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/vwcorkill')}
        >
          VW Corkills Cleaning Checklist
        </button>
        <button
          style={hovered === 10 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(10)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/surgery')}
        >
          Surgery Audit Form
        </button>
        <button
          style={hovered === 11 ? { ...styles.button, ...styles.buttonHover } : styles.button}
          onMouseEnter={() => setHovered(11)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/kensite')}
        >
          Kensite Cleaning Checklist
        </button>

        <button
          style={hovered === 12 ? { ...styles.dashboardButton, ...styles.buttonHover } : styles.dashboardButton}
          onMouseEnter={() => setHovered(12)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => navigate('/pdf-dashboard')}
        >
          PDF Forms Library
        </button>
      </div>
    </div>
  );
}
